import { SectionContent } from '../../../components/landings/styles'

import IntroBanner from './IntroBanner'
import Paragraph from './Paragraph'
import { Section, StrongText } from './Section'
import { SectionContainer } from './SectionContainer'
import SectionTitle from './SectionTitle'

import styles from './RewardsProgramCampaignSectionIntro.module.scss'

const RewardsProgramCampaignIntro = () => {
  return (
    <Section $padding='none'>
      <SectionContainer>
        <IntroBanner />
        {/* Paddings 3/8 on every viewport (mobile values set explicitly, as
            the former styled(SectionContent) override applied unconditionally) */}
        <SectionContent
          className={styles.introContent}
          $top={3}
          $bottom={8}
          $topMobile={3}
          $bottomMobile={8}
        >
          <SectionTitle as='h1'>… bo Twój wybór ma znaczenie!</SectionTitle>
          <Paragraph className={styles.paragraph}>
            W Lokalnym Rolniku wierzymy, że zakup jedzenia to coś więcej niż
            tylko pełna lodówka. To codzienny wybór jakości i zdrowia, bo to co
            trafia na Twój stół, ma znaczenie. Każde zamówienie to także realne
            wsparcie dla małych gospodarstw, lokalnych wytwórców i
            rzemieślników, którzy wkładają w swoją pracę serce, dbają o tradycję
            i smak.
          </Paragraph>
          <Paragraph className={styles.paragraph}>
            Dziękujemy, że jesteś z nami i tworzysz społeczność Lokalnego
            Rolnika! W ramach docenienia, postanowiliśmy od czasu do czasu
            dorzucić do Twojego zamówienia{' '}
            <StrongText>drobny, praktyczny prezent.</StrongText>
          </Paragraph>
        </SectionContent>
      </SectionContainer>
    </Section>
  )
}

export default RewardsProgramCampaignIntro
